module.exports = __webpack_public_path__ + "static/media/alert.c78d37b9.svg";